"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    icon_url: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render: function render(h, context) {
    var _context$props = context.props,
      icon = _context$props.icon,
      title = _context$props.title,
      icon_url = _context$props.icon_url;
    var vnodes = [];
    if (icon) {
      var a = 'el-icon-' + icon;
      vnodes.push(h("i", {
        "class": a
      }));
    }
    if (icon_url) {
      vnodes.push(h("img", {
        "attrs": {
          "src": icon_url
        },
        "style": 'width:16px;height:16px;margin-right:8px;'
      }));
    }
    if (title) {
      vnodes.push(h("span", {
        "slot": 'title'
      }, [title]));
    }
    return vnodes;
  }
};
exports.default = _default;